import ROUTES from '../../assets/routes'
import { matchRoute } from '../../util/routes'
import type { AgentDomain } from './surfaceRegistry'

/** Domain the user is currently looking at, independent of the conversation's domain. */
export function routeDomain(pathname: string): AgentDomain | null {
    if (matchRoute(pathname, [{ path: ROUTES.chart, key: 'chart' }])) return 'chart'
    if (matchRoute(pathname, [{ path: ROUTES.screener, key: 'screener' }])) return 'screener'
    return null
}
